import type { ComponentProps } from "react";
import { AdminDataNotice } from "@/components/admin/data-notice";
import { SettingsView } from "@/components/admin/prospection/settings-view";
import { useView, usePageTitle } from "@shared/client/view";

export default function ProspectionSettingsPage() {
  usePageTitle("Réglages — Prospection — Administration Hune");
  const { data, error } = useView<ComponentProps<typeof SettingsView>>("/api/views/admin/prospection/settings");
  if (error) return <AdminDataNotice error={error} />;
  if (!data) return null;
  return <SettingsView {...data} />;
}
